//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import {
  IGetMediaItemsByCuidResult,
  MediaStringRecord,
} from '@apis/media-library/mediaLibraryApiModel';
import { deserializeMediaItem } from '@apis/media-library/mediaLibraryApiUtils';
import Cuid from '@models/Cuid';
import { makeParams } from '@utils/makeParams';
import { mapObject } from '@utils/mapObject';
import { serializedGatewayFetch } from '@utils/sessionFetch';

function mediaLibraryGatewayFetch(endpoint: string, init?: RequestInit) {
  return serializedGatewayFetch(
    'web_gateway',
    `/api/v2/media/library${endpoint}`,
    init,
  );
}

/**
 *
 * Gets a collection of hydrated media items for the given set of cuids
 *
 * /api/v2/media-items/
 *
 * @param cuid the set of cuids to hydrate
 *
 * @returns List of media items as a promise
 */
export async function getMediaItemsByCuid(
  cuid: Cuid[],
  init?: RequestInit,
): Promise<MediaStringRecord> {
  const params = makeParams({ cuid });

  const res = await mediaLibraryGatewayFetch(`/media-items?${params}`, init);
  const response: IGetMediaItemsByCuidResult =
    await res.json<IGetMediaItemsByCuidResult>((r) => ({
      data: {
        media: mapObject(r.data.media, deserializeMediaItem),
      },
    }));
  return response.data.media;
}
